import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IntercomModule } from '@y42/intercom';
import { ColumnTypeIconModule } from '@y42/column-type';
import { ColumnTypePipe } from './pipes/column-type.pipe';
import { FilterFieldsPipe } from './pipes/filter-fields.pipe';
import { TargetColumnComponent } from './target-column.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatMenuModule,
    MatInputModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ColumnTypeIconModule,
    ReactiveFormsModule,
    IntercomModule,
  ],
  declarations: [TargetColumnComponent, ColumnTypePipe, FilterFieldsPipe],
  exports: [TargetColumnComponent],
})
export class TargetColumnModule {}
